export const useFocusableElements =
  (root: HTMLElement | Document | null = document) =>
  () => {
    if (root) {
      return root.querySelectorAll<HTMLElement>(
        `button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), video`
      );
    }
  };
